import {
    setAccessoriesAboveEspCollapse,
    setAccessoriesBelowEspCollapse,
    setAddChargePumpCollapse,
    setCableClearingCollapse,
    setCasingCollapse,
    setChargePump1Collapse,
    setChargePump2Collapse,
    setChargePump3Collapse,
    setCompositePumpPerformanceCurvesCollapse,
    setControllerCollapse,
    setCorrelationCollapse,
    setEspEquipmentCollapse,
    setFluidCollapse,
    setFluidVelocityCollapse,
    setGasHandlerCollapse,
    setGasImpuritiesCollapse,
    setGasPropertyCollapse,
    setGasSeparatorCollapse,
    setGasVolumeCollapse,
    setHarmonicFilterCollapse,
    setIprTypeCollapse,
    setLinerCollapse,
    setMaximumPressureCollapse,
    setMiscellaneousCollapse,
    setMotorListCollapse,
    setMotorPerformanceCollapse,
    setNotesCollapse,
    setOilContractionsCollapse,
    setOilPropertyCollapse,
    setOthersCollapse,
    setOthersTabCollapse,
    setPerformanceCurvesCollapse,
    setPerformanceCurvesPumpCollapse,
    setPowerConditionsCollapse,
    setProblemsCollapse,
    setProjectSummaryCollapse,
    setProtectorCalculationsCollapse,
    setProtectorListCollapse,
    setPumpCalculationsCollapse,
    setPumpIterationsCollapse,
    setPumpListCollapse,
    setBOHCollapse,
    setRecommendedParametersCollapse,
    setRecommendedParametersMotorCollapse,
    setSelectedMotorListCollapse,
    setSelectedProtectorListCollapse,
    setSensorCollapse,
    setSetDepthSummaryCollapse,
    setSettingDepthCollapse,
    setSummaryCollapse,
    setSurfaceConditionsCollapse,
    setSurfaceEquipmentCollapse,
    setSurfaceVoltageCollapse,
    setTdhCalculationsCollapse,
    setTransformersCollapse,
    setTubingCollapse,
    setWellInflowCalculationsCollapse,
    setWellIprCalculationsCollapse,
    setMotorCalculationsCollapse,
    setMotorPerformmanceDataCollapse,
    setMotorRatingCollapse,
    setFluidVelocityCheckCollapse,
    setGasFormulasCollapse,
    setGasHandlersCollapse,
    setGasChargePumpCollapse,
    setBasicWIFCollapse,
    setBasicIPRCollapse,
    setBasicTDHCollapse,
    setPumpCollapse,
    setOilContractionCollapse,
    setProtectorCollapse,
    setCableCleavoltCollapse,
    setSurfaceVoltCollapse,
    setBaseLineCollapse,
    setWapperHarmonicFilterCollapse,
    setWappertwoCollapse

} from "../store/collapse/collaspeSlice";
import { useAppDispatch } from "../store/hooks/StoreHooks";

const useCollapseFacade = () => {
    const dispatch = useAppDispatch();
    const updateGasFormulasCollapse = (payload: boolean) => {
        return dispatch(setGasFormulasCollapse(payload));
    };
    const updateGasHandlersCollapse = (payload: boolean) => {
        return dispatch(setGasHandlersCollapse(payload));
    };
    const updateGasChargePumpCollapse = (payload: boolean) => {
        return dispatch(setGasChargePumpCollapse(payload));
    };
    const updateBasicWIFCollapse = (payload: boolean) => {
        return dispatch(setBasicWIFCollapse(payload));
    };
    const updateBasicIPRCollapse = (payload: boolean) => {
        return dispatch(setBasicIPRCollapse(payload));
    };
    const updateBasicTDHCollapse = (payload: boolean) => {
        return dispatch(setBasicTDHCollapse(payload));
    };
    const updateMotorCalculationsCollapse = (payload: boolean) => {
        return dispatch(setMotorCalculationsCollapse(payload));
    };
    const updateMotorPerformmanceDataCollapse = (payload: boolean) => {
        return dispatch(setMotorPerformmanceDataCollapse(payload));
    };
    const updateMotorRatingCollapse = (payload: boolean) => {
        return dispatch(setMotorRatingCollapse(payload));
    };
    const updatePumpCollapse = (payload: boolean) => {
        return dispatch(setPumpCollapse(payload));
    };
    
    const updateFluidVelocityCheckCollapse = (payload: boolean) => {
        return dispatch(setFluidVelocityCheckCollapse(payload));
    };
    const updateOilContractionCollapse = (payload: boolean) => {
        return dispatch(setOilContractionCollapse(payload));
    };
    const updateProtectorCollapse = (payload: boolean) => {
        return dispatch(setProtectorCollapse(payload));
    };
    const updateCableCleavoltCollapse = (payload: boolean) => {
        return dispatch(setCableCleavoltCollapse(payload));
    };
    const updateSurfaceVoltCollapse = (payload: boolean) => {
        return dispatch(setSurfaceVoltCollapse(payload));
    };
    const updateBaseLineCollapse = (payload: boolean) => {
        return dispatch(setBaseLineCollapse(payload));
    };
    const updateWappertwoCollapse = (payload: boolean) => {
        return dispatch(setWappertwoCollapse(payload));
    };
    const updateWapperHarmonicFilterCollapse = (payload: boolean) => {
        return dispatch(setWapperHarmonicFilterCollapse(payload));
    };
    const updateProtectorListCollapse = (payload: boolean) => {
        return dispatch(setProtectorListCollapse(payload));
    };

    const updateProtectorCalculationsCollapse = (payload: boolean) => {
        return dispatch(setProtectorCalculationsCollapse(payload));
    };

    const updateOilProtectionsCollapse = (payload: boolean) => {
        return dispatch(setOilContractionsCollapse(payload));
    };

    const updateSelectedProtectorListCollapse = (payload: boolean) => {
        return dispatch(setSelectedProtectorListCollapse(payload));
    };

    const updateCasingCollapse = (payload: boolean) => {
        return dispatch(setCasingCollapse(payload));
    };

    const updateTubingCollapse = (payload: boolean) => {
        return dispatch(setTubingCollapse(payload));
    };

    const updateLinerCollapse = (payload: boolean) => {
        return dispatch(setLinerCollapse(payload));
    };

    const updateCableClearingCollapse = (payload: boolean) => {
        return dispatch(setCableClearingCollapse(payload));
    };

    const updateSurfaceVoltageCollapse = (payload: boolean) => {
        return dispatch(setSurfaceVoltageCollapse(payload));
    };

    const updateAccessoriesAboveEspCollapse = (payload: boolean) => {
        return dispatch(setAccessoriesAboveEspCollapse(payload));
    };

    const updateEspEquipmentCollapse = (payload: boolean) => {
        return dispatch(setEspEquipmentCollapse(payload));
    };

    const updateAccessoriesBelowEspCollapse = (payload: boolean) => {
        return dispatch(setAccessoriesBelowEspCollapse(payload));
    };

    const updateMiscellaneousCollapse = (payload: boolean) => {
        return dispatch(setMiscellaneousCollapse(payload));
    };

    const updateSetDepthSummaryCollapse = (payload: boolean) => {
        return dispatch(setSetDepthSummaryCollapse(payload));
    };

    const updateRecommendedParametersCollapse = (payload: boolean) => {
        return dispatch(setRecommendedParametersCollapse(payload));
    };

    const updateSurfaceEquipmentCollapse = (payload: boolean) => {
        return dispatch(setSurfaceEquipmentCollapse(payload));
    };

    const updateControllerCollapse = (payload: boolean) => {
        return dispatch(setControllerCollapse(payload));
    };

    const updateTransformersCollapse = (payload: boolean) => {
        return dispatch(setTransformersCollapse(payload));
    };

    const updateHarmonicFilterCollapse = (payload: boolean) => {
        return dispatch(setHarmonicFilterCollapse(payload));
    };

    const updatePerformanceCurvesCollapse = (payload: boolean) => {
        return dispatch(setPerformanceCurvesCollapse(payload));
    };

    const updateSurfaceConditionsCollapse = (payload: boolean) => {
        return dispatch(setSurfaceConditionsCollapse(payload));
    };

    const updateIprTypeCollapse = (payload: boolean) => {
        return dispatch(setIprTypeCollapse(payload));
    };

    const updateSettingDepthCollapse = (payload: boolean) => {
        return dispatch(setSettingDepthCollapse(payload));
    };

    const updateFluidCollapse = (payload: boolean) => {
        return dispatch(setFluidCollapse(payload));
    };

    const updateOilPropertyCollapse = (payload: boolean) => {
        return dispatch(setOilPropertyCollapse(payload));
    };

    const updateGasPropertyCollapse = (payload: boolean) => {
        return dispatch(setGasPropertyCollapse(payload));
    };

    const updateGasVolumeCollapse = (payload: boolean) => {
        return dispatch(setGasVolumeCollapse(payload));
    };

    const updateOthersCollapse = (payload: boolean) => {
        return dispatch(setOthersCollapse(payload));
    };

    const updateCorrelationCollapse = (payload: boolean) => {
        return dispatch(setCorrelationCollapse(payload));
    };

    const updatePowerConditionsCollapse = (payload: boolean) => {
        return dispatch(setPowerConditionsCollapse(payload));
    };

    const updateGasImpuritiesCollapse = (payload: boolean) => {
        return dispatch(setGasImpuritiesCollapse(payload));
    };

    const updateProblemsCollapse = (payload: boolean) => {
        return dispatch(setProblemsCollapse(payload));
    };

    const updateOthersTabCollapse = (payload: boolean) => {
        return dispatch(setOthersTabCollapse(payload));
    };

    const updateNotesCollapse = (payload: boolean) => {
        return dispatch(setNotesCollapse(payload));
    };

    const updateSummaryCollapse = (payload: boolean) => {
        return dispatch(setSummaryCollapse(payload));
    };

    const updateGasSeparatorCollapse = (payload: boolean) => {
        return dispatch(setGasSeparatorCollapse(payload));
    };

    const updateGasHandlerCollapse = (payload: boolean) => {
        return dispatch(setGasHandlerCollapse(payload));
    };

    const updateAddChargePumpCollapse = (payload: boolean) => {
        return dispatch(setAddChargePumpCollapse(payload));
    };

    const updateChargePump1Collapse = (payload: boolean) => {
        return dispatch(setChargePump1Collapse(payload));
    };

    const updateChargePump2Collapse = (payload: boolean) => {
        return dispatch(setChargePump2Collapse(payload));
    };

    const updateChargePump3Collapse = (payload: boolean) => {
        return dispatch(setChargePump3Collapse(payload));
    };

    const updateProjectSummaryCollapse = (payload: boolean) => {
        return dispatch(setProjectSummaryCollapse(payload));
    };

    const updatePumpCalculationsCollapse = (payload: boolean) => {
        return dispatch(setPumpCalculationsCollapse(payload));
    };

    const updatePumpListCollapse = (payload: boolean) => {
        return dispatch(setPumpListCollapse(payload));
    };

    const updateBOHCollapse = (payload: boolean) => {
        return dispatch(setBOHCollapse(payload));
    }

    const updatePerformanceCurvesPumpCollapse = (payload: boolean) => {
        return dispatch(setPerformanceCurvesPumpCollapse(payload));
    };

    const updateMaximumPressureCollapse = (payload: boolean) => {
        return dispatch(setMaximumPressureCollapse(payload));
    };

    const updateCompositePumpPerformanceCurvesCollapse = (payload: boolean) => {
        return dispatch(setCompositePumpPerformanceCurvesCollapse(payload));
    };

    const updatePumpIterationCollapse = (payload: boolean) => {
        return dispatch(setPumpIterationsCollapse(payload));
    };

    const updateWellInflowCalculationsCollapse = (payload: boolean) => {
        return dispatch(setWellInflowCalculationsCollapse(payload));
    };

    const updateWellIprCalculationsCollapse = (payload: boolean) => {
        return dispatch(setWellIprCalculationsCollapse(payload));
    };

    const updateTdhCalculationsCollapse = (payload: boolean) => {
        return dispatch(setTdhCalculationsCollapse(payload));
    };

    const updateMotorListCollapse = (payload: boolean) => {
        return dispatch(setMotorListCollapse(payload));
    };

    const updateSelectedMotorListCollapse = (payload: boolean) => {
        return dispatch(setSelectedMotorListCollapse(payload));
    };

    const updateMotorPerformanceCollapse = (payload: boolean) => {
        return dispatch(setMotorPerformanceCollapse(payload));
    };

    const updateFluidVelocityCollapse = (payload: boolean) => {
        return dispatch(setFluidVelocityCollapse(payload));
    };

    const updateSensorCollapse = (payload: boolean) => {
        return dispatch(setSensorCollapse(payload));
    };

    const updateRecommendedParametersMotorCollapse = (payload: boolean) => {
        return dispatch(setRecommendedParametersMotorCollapse(payload));
    };


    return {
        updateProtectorListCollapse,
        updateProtectorCalculationsCollapse,
        updateOilProtectionsCollapse,
        updateSelectedProtectorListCollapse,
        updateCasingCollapse,
        updateTubingCollapse,
        updateLinerCollapse,
        updateCableClearingCollapse,
        updateSurfaceVoltageCollapse,
        updateAccessoriesAboveEspCollapse,
        updateEspEquipmentCollapse,
        updateAccessoriesBelowEspCollapse,
        updateMiscellaneousCollapse,
        updateSetDepthSummaryCollapse,
        updateRecommendedParametersCollapse,
        updateSurfaceEquipmentCollapse,
        updateControllerCollapse,
        updateTransformersCollapse,
        updateHarmonicFilterCollapse,
        updatePerformanceCurvesCollapse,
        updateSurfaceConditionsCollapse,
        updateIprTypeCollapse,
        updateSettingDepthCollapse,
        updateFluidCollapse,
        updateOilPropertyCollapse,
        updateGasPropertyCollapse,
        updateGasVolumeCollapse,
        updateOthersCollapse,
        updateCorrelationCollapse,
        updatePowerConditionsCollapse,
        updateGasImpuritiesCollapse,
        updateProblemsCollapse,
        updateOthersTabCollapse,
        updateNotesCollapse,
        updateSummaryCollapse,
        updateGasSeparatorCollapse,
        updateGasHandlerCollapse,
        updateAddChargePumpCollapse,
        updateChargePump1Collapse,
        updateChargePump2Collapse,
        updateChargePump3Collapse,
        updateProjectSummaryCollapse,
        updatePumpCalculationsCollapse,
        updatePumpListCollapse,
        updateBOHCollapse,
        updatePerformanceCurvesPumpCollapse,
        updateMaximumPressureCollapse,
        updateCompositePumpPerformanceCurvesCollapse,
        updatePumpIterationCollapse,
        updateWellInflowCalculationsCollapse,
        updateWellIprCalculationsCollapse,
        updateTdhCalculationsCollapse,
        updateMotorListCollapse,
        updateSelectedMotorListCollapse,
        updateMotorPerformanceCollapse,
        updateFluidVelocityCollapse,
        updateSensorCollapse,
        updateRecommendedParametersMotorCollapse,
        updateMotorCalculationsCollapse,
        updateMotorPerformmanceDataCollapse,
        updateMotorRatingCollapse,
        updateFluidVelocityCheckCollapse,
        updateGasFormulasCollapse,
        updateGasHandlersCollapse,
        updateGasChargePumpCollapse,
        updateBasicWIFCollapse,
        updateBasicIPRCollapse,
        updateBasicTDHCollapse,
        updatePumpCollapse,
        updateOilContractionCollapse,
        updateProtectorCollapse,
        updateCableCleavoltCollapse,
        updateSurfaceVoltCollapse,
        updateBaseLineCollapse,
        updateWappertwoCollapse,
        updateWapperHarmonicFilterCollapse
    };
};

export default useCollapseFacade;
